import { render, staticRenderFns } from "./ReservationDetails.vue?vue&type=template&id=4b495b44&scoped=true"
import script from "./ReservationDetails.vue?vue&type=script&lang=js"
export * from "./ReservationDetails.vue?vue&type=script&lang=js"
import style0 from "./ReservationDetails.vue?vue&type=style&index=0&id=4b495b44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b495b44",
  null
  
)

export default component.exports